// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"a9a50390","627":"002766b5","638":"e3301c6d","955":"61f6137b"}[chunkId] + ".chunk.js";
};